import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme, transientOptions } from "shared/lib/styles";

export const Label = styled.span`
  padding-block-start: 11px;

  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;
  white-space: nowrap;
`;

type ContainerProps = {
  $backgroundColor: string;
  $iconFillColor?: string;
  $mobilePadding: number;
  $padding: number;
  $size: number;
  $svgTransform?: string;
};

export const StyledIconContainer = styled("span", { ...transientOptions })<ContainerProps>`
  display: flex;
  /* use padding the inline-size is not equal to the block-size */

  inline-size: ${props => props.$size + props.$mobilePadding * 2}px;
  block-size: ${props => props.$size + props.$mobilePadding * 2}px;
  padding: ${props => props.$mobilePadding}px;

  border-radius: 200px;

  background-color: ${props => props.$backgroundColor};

  ${theme.breakpoints.up("tablet")} {
    inline-size: ${props => props.$size + props.$padding * 2}px;
    block-size: ${props => props.$size + props.$padding * 2}px;
    padding: ${props => props.$padding}px;
  }

  svg {
    inline-size: ${props => props.$size}px;
    block-size: ${props => props.$size}px;
    ${props =>
      props.$iconFillColor &&
      css`
        path {
          fill: ${props.$iconFillColor};
        }
      `}

    ${props =>
      props.$svgTransform &&
      css`
        transform: ${props.$svgTransform};
      `}
  }
`;
